import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { VIEW, EDIT, YES, ACTIVE } from "const"
import {
    StoreType,
    setLifecycleBaseRoute,
    moduleIds,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    lifecyclesRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"
import List from "./list"
import View from "./view"
import Edit from "./edit"

const Lifecycle = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const dispatch = useDispatch()

    const { lifecycleModuleAccess } = packageSettings
    const moduleAccess = lifecycleModuleAccess === YES && moduleList[moduleIds.lifecycle].status === ACTIVE
    const access = userData.accountId === 1 || moduleAccess

    const baseRouteMask = project.id ? `${projectBaseRoute}${lifecyclesRoute}` : lifecyclesRoute
    const baseRoute = project.id ? `${projectsRoute}/${VIEW}/${project.id}${lifecyclesRoute}` : lifecyclesRoute

    useEffect(() => {
        dispatch(setLifecycleBaseRoute(baseRoute))
    }, [])

    if (!access) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/${VIEW}/:lifecycleId`}
                component={View}
            />
            <Route
                path={`${baseRouteMask}/${EDIT}/:lifecycleId`}
                component={Edit}
            />
            <Route
                path={baseRouteMask}
                component={List}
            />
        </Switch>
    )
}
export default Lifecycle
